import {
  type APISlideAttributes,
  type ArdoqId,
  isVisualizationSlide,
} from '@ardoq/api-types';
import { AppModules } from 'appContainer/types';
import type { AppRouterLocation } from 'router/declarative/location$';
import { getSearchParam } from 'router/declarative/locationParams';

export type SelectedSlideSources = {
  openedSlideId: ArdoqId | null;
  slidesById: Record<ArdoqId, APISlideAttributes>;
  selectedModule: AppModules;
  location: AppRouterLocation;
};

export const toUrlSelectedSlideId = (
  location: AppRouterLocation
): ArdoqId | null => {
  if (location.kind !== 'matched') return null;
  return getSearchParam(location, 'selectedSlide') ?? null;
};

const toOpenedVisualizationSlideId = (
  openedSlideId: ArdoqId | null,
  slidesById: Record<ArdoqId, APISlideAttributes>
): ArdoqId | null => {
  if (!openedSlideId) return null;
  const slide = slidesById[openedSlideId];
  if (slide && !isVisualizationSlide(slide)) return null;
  return openedSlideId;
};

/**
 * The selected slide is the `selectedSlide` search param of the URL.
 *
 * The workspace module's URL is written by the StreamRouter, which `location$`
 * does not follow and which writes the selected slide into the URL itself.
 * There the selected slide is the opened slide, while it is a visualization
 * slide or not loaded yet.
 */
export const toSelectedSlideId = ({
  openedSlideId,
  slidesById,
  selectedModule,
  location,
}: SelectedSlideSources): ArdoqId | null => {
  if (selectedModule === AppModules.WORKSPACES) {
    return toOpenedVisualizationSlideId(openedSlideId, slidesById);
  }
  return toUrlSelectedSlideId(location);
};
